import React from 'react'

import { IconChevronFilledDown, IconChevronFilledUp } from '@avantstay/backoffice-vectors'

import { TableHeaderItemStyled as TableHeaderItem } from '../Table.styles'
import { SORT_DIRECTION_ASC, SORT_DIRECTION_DESC } from '../../../constants'
import { mainColors } from '../../../styles'
import { FlexDirectionType, JustifyContentType } from './_types'
import * as S from './SortableTableHeaderItem.styles'

type ColumnDirectionType = typeof SORT_DIRECTION_ASC | typeof SORT_DIRECTION_DESC
interface ISortableTableHeaderItemProps {
  children: React.ReactNode
  className?: string
  columnDirection: ColumnDirectionType
  colWidth?: string
  flexDirection?: FlexDirectionType
  justifyContent?: JustifyContentType
  borderRight?: string
  borderLeft?: string
  isActive: boolean
  minColWidth?: string
  maxColWidth?: string
  onTableSort: (columnToSort: string) => void
  sortBy: string
  dataCy?: string
  disableSort?: boolean
}

export function SortableTableHeaderItem({
  children,
  className,
  columnDirection,
  colWidth,
  flexDirection = 'row',
  isActive,
  justifyContent = 'flex-start',
  borderRight,
  borderLeft,
  minColWidth,
  maxColWidth,
  onTableSort,
  sortBy,
  dataCy,
  disableSort,
}: ISortableTableHeaderItemProps): JSX.Element {
  const isAsc = isActive && columnDirection === SORT_DIRECTION_ASC
  const isDesc = isActive && columnDirection === SORT_DIRECTION_DESC

  return (
    <TableHeaderItem
      className={className}
      colWidth={colWidth}
      minColWidth={minColWidth}
      maxColWidth={maxColWidth}
      onClick={() => !disableSort && onTableSort(sortBy)}
      data-cy={dataCy}
      borderRight={borderRight}
      borderLeft={borderLeft}
    >
      <S.SortableContainer flexDirection={flexDirection} justifyContent={justifyContent}>
        {children}
        {!disableSort && (
          <S.IconContainer>
            <IconChevronFilledUp
              color={isAsc ? mainColors.neutralExtremelyDark : mainColors.neutralDark}
            />
            <IconChevronFilledDown
              color={isDesc ? mainColors.neutralExtremelyDark : mainColors.neutralDark}
            />
          </S.IconContainer>
        )}
      </S.SortableContainer>
    </TableHeaderItem>
  )
}
